
<div class="popup-wrapper">
    <div class="popup-header">
        <span class="material-icons cyan">inventory</span>
        <span class="soc-panel-h">{{ (inventory.id == null ? "INVENTORY.NEW" : "INVENTORY.EDIT")  | translate }}</span>
    </div>
    <hr class="soc-panel-line">
    <form #f="ngForm" class="soc-form-wrapper-gap-24">
        <div class="soc-input-wrapper">
            <label for="name" class="soc-input-lbl w-100 text-start">{{'INVENTORY.NAME'| translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="name.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': name.invalid && f.submitted}" id="name" required name="name" #name="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="inventory.name">
            </div>
        </div>
        <div class="soc-input-wrapper">
            <label for="users" class="soc-input-lbl w-100 text-start" style="line-height: 24px;">{{'INVENTORY.INVENTORY_MANAGERS' | translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="users.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon" >info</span>
                <p-multiSelect [ngClass]="{'soc-error-active-dropdown': users.invalid && f.submitted}" id="users" required name="users" #users="ngModel" appendTo="body" class="soc-multiselect" [showClear]="true" [virtualScroll]="true" [filter]="true" [options]="employees" dataKey="id" [(ngModel)]="inventory.managers" placeholder="{{'INVENTORY.SELECT_EMPLOYEES' | translate}}" [showHeader]="false">
                    <ng-template let-users pTemplate="selectedItems">
                        <div *ngIf="!users || users.length == 0">{{'INVENTORY.SELECT_EMPLOYEES' | translate}}</div>
                        <div *ngIf="users && users.length == 1">{{ users[0].firstName }} {{ users[0].lastName }}</div>
                        <div *ngIf="users && users.length > 1" class="multiple-selected">{{ users.length }} Selected</div>
                    </ng-template>
                    <ng-template let-user pTemplate="item">
                        <span>{{user.firstName}} {{user.lastName}}</span>
                    </ng-template>
                </p-multiSelect>
            </div>
        </div>
        <div class="soc-wrapper-gap-8">
            <div class="soc-checkbox-statement">
                <p-checkbox [binary]="true"  [(ngModel)]="inventory.isMain" [ngModelOptions]="{standalone: true}" [disabled]="disableMainInventorySelection && !inventory.isMain"></p-checkbox>
                <span class="soc-display-lbl soc-neutral-text-color">{{'INVENTORY.MAIN_INVENTORY' | translate}}</span>
            </div>
            <div pTooltip="{{'INVENTORY.MAIN_INVENTORY_EXPLANATION' | translate}}" tooltipPosition="bottom" class="material-icons soc-info">info </div>
        </div>
        <hr class="soc-panel-line">
        <div class="soc-wrapper-gap-12 d-flex justify-content-end">
            <button class="soc-secondary-grey-btn" type="button"  (click)="close()">{{'CLOSE' | translate}}</button>
            <button class="soc-basic-cyan-btn" type="submit" (click)="save(f)">{{'SAVE' | translate}}</button>
        </div>
    </form>
</div>